import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Header from './Header';
import Name from './Name';
import City from './City';
import Date from './Date';
import Description from './Description';
import PopUp from './PopUp';
import { ButtonTestCss } from "../../ButtonStyle";
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckFormatDate } from '../../Moment/Moment';
import { Requestdynamic } from '../../Network/Fetch';
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import PublicView from './PublicView';
import Cookies from 'universal-cookie';
import Target from './Target';
import SelectEventModal from './SelectEventModal';

class EditGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      verifyArgument: false,
      editGallery: false,
      Year: null,
      Day: null,
      Month: null,
      Error: null,
      Name: null,
      City: "",
      Target: null,
      Editor: EditorState.createEmpty(),
      openModal: false,
      title: null,
      message: null,
      success: false,
      Public: false,
      linkedEvent: null,
      openSelectEventModal: false,
      injectSearchTerm: null,
      isSelectableEvent: false,
    };
    this.eventCardRef = React.createRef();
  }

  _VerifySource = async () => {
    this.setState({ verifyArgument: true }, async () => {
      const { location, match } = this.props.navigation;
      const state = location?.state;
      const idgallery = match?.params?.idgallery;

      if (!state || !idgallery || !CheckFormatDate(state.Date, 'YYYY/MM/DD')) {
        this.setState({ verifyArgument: false, openModal: true, title: 'Error', redirect: true, message: 'Un problème est survenue veuillez réesayer plus tard' });
        return;
      }

      const [Year, Month, Day] = state.Date.split('/');
      const paramsSetState = {
        verifyArgument: false,
        Name: state.Name,
        City: state.City || "",
        Target: state.Target || "FR",
        Month,
        Day,
        Year,
        Public: state.Public,
        IdGallery: idgallery,
        linkedEvent: state.Event || null,
        isSelectableEvent: !state.Event,
      };

      if (state.Description != null)
        paramsSetState.Editor = EditorState.createWithContent(convertFromRaw(state.Description));

      this.setState(paramsSetState);
    });
  }

  componentDidMount() {
    this._VerifySource();
    this.goBack = this.goBack.bind(this);
  }

  goBack = () => {
    const { navigation } = this.props;
    if (!navigation.location.state) {
      navigation.history.push('/all_gallery/');
    } else {
      navigation.history.goBack();
    }
  }

  _ConvertToRaw = () => {
    try {
      return this.state.Editor ? convertToRaw(this.state.Editor.getCurrentContent()) : null;
    } catch {
      return "erreur";
    }
  }

  _CheckDate = (Error) => {
    const { Year, Month, Day } = this.state;
    if (!Year || !Month || !Day || !CheckFormatDate(`${Year}/${Month}/${Day}`, "YYYY/MM/DD")) {
      Error.Date = true;
    }
  }

  _CheckName = (Error) => {
    if (!this.state.Name || this.state.Name.length === 0)
      Error.Name = true;
  }

  sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  _editGallery = async () => {
    this.setState({ editGallery: true, Error: null }, async () => {
      const Error = {};
      if (!this.state.linkedEvent) {
        Error.Event = true;
      }
      if (Error.Event && this.eventCardRef.current) {
        this.eventCardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      this._CheckDate(Error);
      this._CheckName(Error);
      const Description = this._ConvertToRaw();

      if (Object.keys(Error).length !== 0) {
        this.setState({ Error, editGallery: false });
        return;
      }

      const cookies = new Cookies();
      const Jwt = cookies.get('acces');
      const City = this.state.City.length === 0 ? null : this.state.City;

      const Params = {
        Name: this.state.Name,
        Target: this.state.Target,
        City,
        Date: `${this.state.Year}/${this.state.Month}/${this.state.Day}`,
        Jwt,
        Description,
        Public: this.state.Public,
        IdGallery: this.state.IdGallery,
        EventId: this.state.linkedEvent.Id
      };

      const promise = await Requestdynamic('_editGallery', Params);

      if (promise.error === false && promise.data.error === false) {
        this.setState({ editGallery: false, openModal: true, title: 'Success', message: "Modifications sauvé !", redirect: true });
      } else if (promise.data?.jwt) {
        cookies.remove('acces', { path: '/' });
        cookies.remove('infoAdmin', { path: '/' });
        await this.sleep(900);
        const link = document.createElement('a');
        link.href = '/login';
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        this.setState({ editGallery: false, openModal: true, title: 'Error', message: "Un problème est survenue veuillez réesayer plus tard" });
      }
    });
  }

  _handleEventSelect = (event) => {
    if (event && event.DateEvent && event.Name) {
      this.setState((prevState) => ({
      linkedEvent: event,
      injectSearchTerm: event.Name,
      Error: { ...prevState.Error, Event: false },
      isSelectableEvent: true
    }));
    }
  };

  _closeEventModal = () => {
  this.setState({
    openSelectEventModal: false,
    injectSearchTerm: null
  });
};

  openEventModal = () => {
  this.setState({ openSelectEventModal: false }, () => {
    this.setState({
      openSelectEventModal: true,
      injectSearchTerm: this.state.Name || ''
    });
  });
};


  renderSelectedEventCard = () => {
    const event = this.state.linkedEvent;
    return (
      <div className="d-flex mt-3 justify-content-center">
        <div   ref={this.eventCardRef}
 className="card p-3 mb-4 shadow-sm" style={{
          maxWidth: '700px',
          width: '100%',
          height: '150px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          border: this.state.Error?.Event ? '2px solid red' : 'none' }}>
          <h6 className="text-muted mb-2">Événement lié :</h6>
          {event ? (
  <div className="d-flex align-items-center justify-content-between">
    <div className="d-flex align-items-center" style={{ height: '100%' }}>
      <div style={{ width: '100px', height: '100px', borderRadius: '8px', overflow: 'hidden', marginRight: '16px', flexShrink: 0 }}>
        <img src={event.Image} alt={event.Name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div>
      <div>
        <h5 className="mb-1">{event.Name}</h5>
        <p className="mb-0 text-muted">{event.DateEvent}</p>
      </div>
    </div>

    {this.state.isSelectableEvent && (
      <ButtonTestCss
        size="sm"
        color="#082430"
        onClick={this.openEventModal}
      >
        Modifier
      </ButtonTestCss>
    )}
  </div>
) : (
  <div className="text-center my-4">
    <ButtonTestCss color="orange" onClick={this.openEventModal}>
      Sélectionner un événement
    </ButtonTestCss>
  </div>
)}
          {this.state.Error?.Event && (
  <div className="text-danger mt-2" style={{ fontWeight: '500' }}>
    Veuillez sélectionner un événement pour continuer.
  </div>
)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={{ marginLeft: 10, overflowY: "auto" }}>
        <Container fluid>
          <SelectEventModal
            show={this.state.openSelectEventModal}
            prefillEventId={null}
            onSelect={this._handleEventSelect}
            onClose={this._closeEventModal}
            injectedSearch={this.state.injectSearchTerm}
          />

          <PopUp
            redirect={this.state.redirect}
            openModal={this.state.openModal}
            message={this.state.message}
            title={this.state.title}
            refParent={this}
          />

          <Header refParent={this} intl={this.props.intl} />

          {this.renderSelectedEventCard()}

          <Name Error={this.state.Error} intl={this.props.intl} Name={this.state.Name} refParent={this} />
          <City Error={this.state.Error} intl={this.props.intl} City={this.state.City} refParent={this} />
          <Target Error={this.state.Error} intl={this.props.intl} Target={this.state.Target} refParent={this} />
          <Date Error={this.state.Error} intl={this.props.intl} Year={this.state.Year} Day={this.state.Day} Month={this.state.Month} refParent={this} />
          <Description intl={this.props.intl} Editor={this.state.Editor} refParent={this} />
          <PublicView refParent={this} Public={this.state.Public} />

          {this.state.Error?.Event && (
            <div className="text-center mb-3 text-danger" style={{ fontWeight: '500' }}>
              Vous devez sélectionner un événement avant de sauvegarder.
            </div>
          )}

          <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Col xl={12} lg={12} md={12} sm={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <ButtonTestCss disabled={this.state.editGallery} color={"orange"} style={{ margin: 10 }} onClick={this._editGallery}>
                {this.state.editGallery ? (
                  <CircularProgress size={"1.5rem"} thickness={5} color={"inherit"} />
                ) : (
                  <p style={{ margin: 0, padding: 0 }}>Sauvegarder</p>
                )}
              </ButtonTestCss>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default EditGallery;
